import { useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'

export function useIsDesktop() {
	const theme = useMantineTheme()
	const isDesktop = useMediaQuery(`(width >= ${theme.breakpoints.xl})`, false, {
		getInitialValueInEffect: false,
	})

	return isDesktop
}

export function useIsTablet() {
	const theme = useMantineTheme()
	const isTablet = useMediaQuery(`(${theme.breakpoints.xs} <= width < ${theme.breakpoints.xl})`)

	return isTablet
}

export function useIsMobile() {
	const theme = useMantineTheme()
	const isMobile = useMediaQuery(`(width < ${theme.breakpoints.xs})`)

	return isMobile
}

export function useIsMobileTabBarLayout() {
	const theme = useMantineTheme()
	const isMobileTabBarLayout = useMediaQuery(`(width < ${theme.breakpoints.sm})`)

	return isMobileTabBarLayout
}
